<script>
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import 'swiper/swiper-bundle.css'

export default {
	components: {
		Swiper,
		SwiperSlide
	},
  computed: {
    comments() {
      return this.siteData?.comments || []
    }
  }
}
</script>

<template>
  <section id="comments" style="background-color: #f4f4f8;">
    <v-container :fluid="isMiniPc" class="py-10">
      <h1 class="text-center font-weight-light display-2 mb-10">Yorumlar</h1>
			<div v-if="comments.length > 0">
				<swiper
					:slides-per-view="$vuetify.breakpoint.smAndUp ? 2 : 1"
					:space-between="30"
					style="height: 250px;"
					:loop="true"
					:autoplay="{ delay: 3000 }"
					class="comments-swiper"
				>
					<swiper-slide
						v-for="comment in comments"
						:key="`comment-${comment.id}`"
					>
						<v-card class="d-flex flex-column justify-center px-5 pb-5 fill-height comment-card" flat>
							<div class="w-100 d-flex justify-center">
									<v-icon color="primary" style="font-size: 60px;">
										mdi-account-circle
									</v-icon>
							</div>
							<div class="text-center grey--text text--darken-2" v-html="comment.comment"></div>
							<h4 class="text-center black--text">{{ comment.name }}</h4>
							<h6 class="text-center grey--text">{{ comment.title }}</h6>
						</v-card>
					</swiper-slide>
				</swiper>
			</div>
    </v-container>
  </section>
</template>

<style lang="scss">
@media screen and (max-width: 600px) {
	.comments-swiper {
		height: 100% !important;
	}
}
</style>